export const C40_EMAIL = "healthyneighbourhood@C40.org";

//ERROR MSG
export const SIMULATION_ERROR = `There was an issue while processing the simulation. Please <a href="mailto:${C40_EMAIL}">contact C40</a> for more information`;